<form [formGroup]="propertyForm" class="form">
    <h3>Property Address for Listing</h3>
    <div formGroupName="address">

        <div class="form-row row-1">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Listed Property</mat-label>
                <mat-select formControlName="propertyId">
                    <mat-option [value]="null">Select a Property</mat-option>
                    <mat-option *ngFor="let property of userProperties" [value]="property.id">
                        {{ property.address.street }} in {{ property.address.city }}, {{ property.address.state }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="propertyForm.get('property')?.hasError('required')">
                    Listed Property is required
                </mat-error>
            </mat-form-field>
        </div>

        <div *ngIf="selectedPropertyPreview" class="selection-preview">
            <mat-card appearance="outlined" class="preview-card">
                <mat-card-header>
                    <mat-icon mat-card-avatar>location_on</mat-icon>
                    <!-- <mat-card-title>Property Auto-Filled</mat-card-title> -->
                    <mat-card-subtitle>Details retrieved from your listing</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <div class="preview-address-details">
                        <table>
                            <tr>
                                <th>Street</th>
                                <td>{{ selectedPropertyPreview.address.street }}</td>
                            </tr>
                            <tr>
                                <th>City</th>
                                <td>{{ selectedPropertyPreview.address.city }}</td>
                            </tr>
                            <tr>
                                <th>State</th>
                                <td>{{ selectedPropertyPreview.address.state }}</td>
                            </tr>
                            <tr>
                                <th>Zip</th>
                                <td>{{ selectedPropertyPreview.address.zipCode }}</td>
                            </tr>
                        </table>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <div class="form-row row-1 hide">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Street Address</mat-label>
                <input matInput formControlName="street">
            </mat-form-field>
        </div>

        <div class="form-row row-3 hide">

            <mat-form-field appearance="outline">
                <mat-label>City</mat-label>
                <input matInput formControlName="city">
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
                <mat-label>State</mat-label>
                <mat-select formControlName="state">
                    <mat-option [value]="null">Select a State</mat-option>
                    <mat-option *ngFor="let state of states" [value]="state">
                        {{ state.name }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="propertyForm.get('state')?.hasError('required')">
                    State is required
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Zip</mat-label>
                <input matInput formControlName="zip">
            </mat-form-field>

        </div>
    </div>

    <h3>Host Information (check one)</h3>
    <div formGroupName="host">
        <div class="form-row row 1">
            <div class="checkbox-group">
                <mat-checkbox [checked]="propertyForm.get('host.role')?.value === 'Property Owner'"
                    (change)="propertyForm.get('host.role')?.setValue('Property Owner')">
                    Property Owner
                </mat-checkbox>
                <mat-checkbox [checked]="propertyForm.get('host.role')?.value === 'Property Manager'"
                    (change)="propertyForm.get('host.role')?.setValue('Property Manager')">
                    Property Manager
                </mat-checkbox>
            </div>
        </div>

        <div class="form-row row-1">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name">
            </mat-form-field>
        </div>

        <div class="form-row row-1">
            <mat-label class="signature-label"><i class="fa-solid fa-file-signature horizinns-green"></i> Signature*</mat-label>
            <span class="signature-instructions">By signing below, the Host acknowledges that the property listed is
                represented through a Sales Consultant with Horizinns, LLC.</span>
            <app-signature [value]="propertyForm.get('host.signatureImage')?.value"
                (signatureConfirmed)="handleSignature($event)" class="margin-auto"></app-signature>
        </div>

        <div class="form-row row-1">
            <mat-form-field appearance="outline">
                <mat-label>Date</mat-label>
                <input matInput type="date" formControlName="date">
            </mat-form-field>
        </div>
    </div>

    <h3>Sales Consultant Information</h3>
    <div formGroupName="consultant">

        <div class="form-row row-1 hide">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name">
            </mat-form-field>
        </div>

        <div class="form-row row-2">

            <mat-form-field appearance="outline">
                <mat-label>Consultant ID</mat-label>
                <input matInput formControlName="id" placeholder="Enter Agent ID">
                <mat-spinner *ngIf="propertyForm.get('consultant.id')?.pending" class="pending" matSuffix diameter="24" style="display: inline-flex; margin-right: 12px;"></mat-spinner>
                @if (propertyForm.get('consultant.id')?.pending) {
                    <!-- <mat-hint class="pending">
                        <mat-icon>pending</mat-icon>
                        Verifying agent...
                    </mat-hint> -->
                    <mat-hint *ngIf="propertyForm.get('consultant.id')?.pending" class="pending">
                        <mat-icon>pending</mat-icon> Verifying Sales Agent...
                    </mat-hint>
                }

                <mat-hint *ngIf="propertyForm.get('consultant.id')?.valid" class="success">
                    <mat-icon>check_circle</mat-icon>
                    Verified Consultant ID
                </mat-hint>

                <mat-error *ngIf="propertyForm.get('consultant.id')?.hasError('agentNotFound')">
                    <mat-icon>error</mat-icon>
                    This Consultant ID is not registered in our system.
                </mat-error>

                <mat-error *ngIf="propertyForm.get('consultant.id')?.hasError('required')">
                    ID is required.
                </mat-error>
                
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Date</mat-label>
                <input matInput type="date" formControlName="date">
            </mat-form-field>

        </div>
    </div>

</form>